import { LOADING } from '../constants/MessageType';
let incrementingId = 0;
export const createLoadingMessage = (source, threadId) => ({
  actions: [],
  displayType: 'LOADING',
  id: incrementingId++,
  query: {
    intent: 'unknown'
  },
  source,
  status: 'loading',
  response: '',
  value: '',
  time: Date.now(),
  thread_id: threadId,
  type: LOADING
});